module.exports = __webpack_public_path__ + "img/cost.d39bc496.png";